import spanishMessages from 'ra-language-spanish';

const commonText = {
    // para evitar textos repetidos varias veces
    descripcion: 'Descripción',
    prestacion: 'Prestación',
    fechaVigencia: 'Fecha de vigencia'
};

// Traducciones que https://github.com/BlackBoxVision/ra-language-spanish todavía no incluyó
spanishMessages.ra.navigation.skip_nav = spanishMessages.ra.navigation.skip_nav || 'Ir al contenido';

const messages = {
    ...spanishMessages,
    app: {
        home: {
            title: 'Validador de reglas'
        },
        dashboard: {
            title: 'Validador',
            subtitle: 'Bienvenido',
        }
    },
    error: {
        generic: {
            title: 'No se pudo realizar la solicitud',
        },
        'role-level': {
            institution: {
                required: 'El rol requiere una institución'
            }
        },
        'resource1': {
            'errorCode1': 'Error code 1',
        },
        forbidden: 'No tiene los permisos necesarios',
        'unknown': 'Ocurrió un error',
    },
    versionar: {
        crear: 'Crear versión'
    },
    reportes: {
        cant_download: 'No se pudo descargar el reporte'
    },
    resources: {
        users: {
            name: 'Usuario |||| Usuarios',
            fields: {
                username: 'Nombre de usuario',
                personId: 'Persona',
                enable: 'Habilitado',
                lastLogin: 'Último ingreso',
                roleId: 'Rol',
                roles0: 'Roles del sistema',
                roles: 'Roles',
                matriculas: 'Matriculas',
            },
            fieldGroups: {
                passwordResets: 'Establecer clave de acceso',
                oauthLogin: 'Acceder como este usuario',
            },
            action: {
                reset: 'Visitar link',
                newReset: 'Generar link',
                login: 'Ingresar',
            }
        },
        personas: {
            name: 'Persona |||| Personas',
            fields: {
                cuil: 'CUIL',
                tipoIdentificacionId: 'Tipo de identificación',
                numeroIdentificacion: 'Nro de identificación',
                generoId: 'Género',
                nroTramite: 'Nro de trámite',
                nombre: 'Nombres',
                apellido: 'Apellidos',
                fechaNacimiento: 'Fecha de nacimiento',
                telefono: 'Teléfono',
                email: 'Correo electrónico',
            },
        },
        'codigo-rechazo': {
            name: 'Código de rechazo |||| Códigos de rechazo',
            fields: {
                id: 'Identificador',
                descripcion: commonText.descripcion,
            },
        },
        'configuraciones-generales': {
            name: 'Configuraciones generales |||| Configuraciones generales',
            title: 'Configuración general',
            fields: {
                idRegla: 'Regla',
                clave: 'Clave',
                descripcion: commonText.descripcion,
                valor: 'Valor',
            }
        },
        excepciones: {
            name: 'Excepción |||| Excepciones',
            fields: {
                idRegla: 'Regla',
                idPrestacion: commonText.prestacion,
            },
        },
        reportes: {
            fields: {
                fechaPrestacion: 'Fecha de prestación'
            },
        },
        'grupo-regla': {
            name: 'Grupo de regla |||| Grupos de reglas',
            fields: {
                id: 'Identificador',
                descripcion: commonText.descripcion,
                fechaVigencia: commonText.fechaVigencia
            },
            tabs: {
                general: "General",
                prestaciones: "Prestaciones",
            },
            titulos: {
                prestaciones: "Prestaciones",
            },
            buttons: {
                agregarPrestacion: "Agregar prestación",
            },
        },
        'grupo-regla-prestaciones': {
            fields: {
                prestacion: commonText.prestacion,
                'grupo-regla': 'Grupo regla'
            }
        },
        'grupo-validaciones': {
            name: 'Categoría de prestaciones |||| Categoría de prestaciones',
            fields: {
                id: 'Identificador',
                descripcion: commonText.descripcion,
                fechaVigencia: commonText.fechaVigencia
            },
            tabs: {
                general: "General",
                prestaciones: "Prestaciones",
            },
            titulos: {
                prestaciones: "Prestaciones",
            },
            buttons: {
                agregarPrestacion: "Agregar prestación",
            },
        },
        prestaciones: {
            name: 'Prestación |||| Prestaciones',
            fields: {
                descripcion: commonText.descripcion,
            },
        },
        regla: {
            name: 'Regla |||| Reglas',
            tabs: {
                general: 'Regla',
                excepciones: 'Excepciones',
                configuraciones: 'Configuraciones',
                'tipo-transaccion': 'Transacciones asociadas',
                etiquetas: 'Etiquetas'
            },
            fields: {
                descripcion: commonText.descripcion,
                tiposRegla: 'Tipo de regla',
                estado: 'Estado',
                descripcionCompleta: 'Descripción completa',
                idCodigoRechazo: 'Código de rechazo',
                idGrupoRegla: 'Grupo de regla',
                idTipoRegla: 'Tipo de regla',
                fechaVigencia: commonText.fechaVigencia,
                desde: 'Fecha inicio de vigencia',
                hasta: 'Fecha fin de vigencia',
                deleted: 'Borrada'
            },
            buttons: {
                crearExcepcion: 'Crear excepción',
                asociarTipoTransaccion: 'Asociar tipo de transacción',
                asociarEtiqueta: 'Asociar etiqueta'
            }
        },
        'regla-tipo-transaccion': {
            name: 'Regla asociadas a un tipo de transacción |||| Regla asociadas a un tipo de transacción ',
            fields: {
                idRegla: 'Regla',
                id: 'Identificador',
                descripcion: commonText.descripcion,
                idTipoTransaccion: 'Tipo de transacción',
                tiposTransaccion: 'Tipo de transacción'
            }
        },
        'historico-validaciones': {
            name: 'Histórico de validaciones |||| Histórico de validaciones',
            fields: {
                id: 'Identificador',
                descripcion: commonText.descripcion,
                prestacion: 'Prestación',
                fechaPrestacion: 'Fecha de prestación',
                createdOn: 'Fecha de solicitud',
                numeroAfiliado: 'Número de afiliado',
            }
        },
        'auditable-validaciones': {
            name: 'Validaciones para auditar |||| Validaciones para auditar',
            fields: {
                id: 'Identificador',
                descripcion: commonText.descripcion,
                prestacion: 'Prestación',
                fechaPrestacion: 'Fecha de prestación',
                createdOn: 'Fecha de solicitud',
                numeroAfiliado: 'Número de afiliado',
            }
        },
        'tipos-transaccion': {
            name: 'Tipo de transacción |||| Tipos de transacciones',
            fields: {
                id: 'Identificador',
                descripcion: commonText.descripcion,
            }
        },
        'estado-regla': {
            name: 'Estados de reglas |||| Estados de reglas',
            fields: {
                id: 'Identificador',
                descripcion: commonText.descripcion,
            }
        },
        'estado-validaciones': {
            name: 'Estados de validaciones |||| Estados de validaciones',
            fields: {
                id: 'Identificador',
                descripcion: commonText.descripcion,
            }
        },
        etiqueta:{
            fields:{
                descripcion: commonText.descripcion,
            }
        },
        'tipos-regla': {
            name: 'Tipos de reglas |||| Tipos de reglas',
            fields: {
                id: 'Identificador',
                descripcion: commonText.descripcion,
            }
        },
        'prestacion-grupo-validaciones': {
            name: 'Prestaciones por categoría |||| Prestaciones por categoría',
            fields: {
                id: 'Identificador',
                descripcion: commonText.descripcion,
                prestacion: commonText.prestacion,
            }
        },
        'prestacion-grupo-regla': {
            name: 'Prestaciones por grupo de regla |||| Prestaciones por grupo de regla ',
            fields: {
                id: 'Identificador',
                descripcion: commonText.descripcion,
            }
        },
        'regla-etiqueta':{
            fields:{
                idEtiqueta:'Etiqueta',
                idRegla:'Regla',
                excluye:'Excluye',
            }
        },
        tope: {
            title: 'Configuración de regla de tope',
            fields: {
                regla: 'Regla',
                valor: 'Valor del tope',
                tipoCondicion: 'Tipo de condición',
                tipoIntervalo: 'Tipo de intervalo',
                cantidadDias: 'Cantidad de días',
                porGrupoFamiliar: 'Por grupo familiar?',
                porPrestadorEfector: 'Por prestador efector?',
                porEntidadEfectora: 'Por entidad efectora?',
                porDiagnostico: 'Por diagnóstico?',
                porGrupoPrestacion: 'Por grupo de prestación?',
            },
            validations: {
                valor: {
                    minValue: 'Inválido, debe ser mayor a cero'
                }
            }
        }
    }
};

export default messages;